module.exports = fox => ({
	isAllowed(source = this.settings.allowedGroups) {
		const pm = this.rwom1('@root #permissionManager');

		return source.some(group => {
			switch (group) {
				case 'guest':
					return pm.hasAccess('guestActual');
				case 'premium':
					return pm.hasAccess('member');
				default:
					return pm.hasAccess(group);
			};
		});
	}
});


// WEBPACK FOOTER //
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/components/liveshow/widget/mixins/isAllowed.es.js